import { render, staticRenderFns } from "./analysisLogisticsModal.vue?vue&type=template&id=6ed4b280&scoped=true&"
import script from "./analysisLogisticsModal.vue?vue&type=script&lang=js&"
export * from "./analysisLogisticsModal.vue?vue&type=script&lang=js&"
import style0 from "./analysisLogisticsModal.vue?vue&type=style&index=0&id=6ed4b280&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed4b280",
  null
  
)

export default component.exports